import { envConfig } from './EnvConfig';

// Redis config
export const RedisTtlConfig = {
    Ttl: envConfig.cacheDefaultTtlSeconds ?? 3600, // 1 hour
    StaleWhileRevalidate: envConfig.cacheDefaultStaleTimeSeconds ?? 1800, // 30 minutes
};

export const RedisConfig = {
    GlobalPrefix: 'headless',
    ...RedisTtlConfig,
};

export const REDIS_KEY_SEPARATOR = ':';

// Server token cache config
export const SERVER_CACHE_TTL_SECONDS = 1200;

export enum ServerTokenCacheKey {
    AccessToken = 'accessToken',
    AccessTokenLastUpdate = 'accessTokenLastUpdate',
}

type TTLExpiresOptions = {
    compareTime: number;
    ttl: number;
};

export const isTTLExpired = (
    lastUpdateTime?: number,
    options: TTLExpiresOptions = { compareTime: Date.now(), ttl: SERVER_CACHE_TTL_SECONDS * 1000 },
): boolean => {
    if (lastUpdateTime === Infinity) {
        // Never expires
        return false;
    }
    if (lastUpdateTime === undefined || lastUpdateTime === null || isNaN(lastUpdateTime)) {
        return true;
    }
    return options.compareTime > lastUpdateTime + options.ttl;
};
